export const serviceOpsConstants = {
    LOADING: 'SERVICEOPS_LOADING',
    ERROR: 'SERVICEOPS_ERROR',
    SET_TAB_VALUE: 'SERVICEOPS_SET_TAB_VALUE',
    TOGGLE_FULL_WIDTH_TABLE: 'SERVICEOPS_TOGGLE_FULL_WIDTH_TABLE'
};